import * as React from 'react';
import { connect } from 'react-redux';

import TransactionReceiptOverlay from '../../components/transactions/TransactionReceiptOverlay';
import { getTransactionById } from '../../actions/transactions';


class TransactionReceiptPopup extends React.Component<any, any> {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getTransactionById(this.props.transactionId));
  }

  onClose = () => {
    this.props.onReturn();
  };

  render() {
    const { transactions, transactionId, locations } = this.props;
    const transaction = transactions.entities[transactionId];

    if (transactions.ui.loading || !transaction) {
      // TODO: Loading
      return (
        <div>Loading</div>
      );
    }

    // TODO: We need to get transaction here and not paycode
    return (
      <TransactionReceiptOverlay
        onClose={this.onClose}
        transaction={transaction}
        location={transaction && locations.entities[transaction.location]}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    transactions: state.shared.transactions,
    locations: state.shared.locations,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransactionReceiptPopup) as any;
